import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { useNavigate } from "react-router-dom";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import {
  Card,
  Stack,
  CardHeader,
  AppBar,
  Tabs,
  Tab,
  styled,
  Badge,
} from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import UserDetailsContext from "../../context/auth";
import MaterialBox from "../../components/MaterialBox";
import { useUserDetails } from "../../context/auth";
import { DesignationContext } from "../../context/designationcontext";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: -1,
    top: -6,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));

const LeaveManagement = () => {
  const navigate = useNavigate();
  const { handleClearSelection } = useContext(DesignationContext);
  const teamleader = JSON.parse(sessionStorage.getItem("user"));
  const tablist = JSON.parse(sessionStorage.getItem("MainApp"));
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const { AccessData, setLeaveShow, HRLIST, SetHRLIST } = useUserDetails();
  const { user, setleavedisplay, setHRRoleLeave, setManagerLeave } =
    useContext(UserDetailsContext);
  const id = user?.id;
  const empid = user?.empid;

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  let MainValue;

  if (
    AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.component === "HrApproval" && item.can_access
    )
  ) {
    if (tablist === "HR") {
      MainValue = "HR";
    } else if (tablist === "HRList") {
      MainValue = "HRList";
    } else {
      MainValue = "Employee";
    }
  }

  if (
    AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.component === "ManagerApproval" && item.can_access
    )
  ) {
    if (tablist === "ManagerList") {
      MainValue = "ManagerList";
    } else {
      MainValue = "Employee";
    }
  }
  if (
    AccessData &&
    Array.isArray(AccessData) &&
    !AccessData.some(
      (item) =>
        item.component === "ManagerApproval" || item.component === "HrApproval"
    )
  ) {
    MainValue = "Employee";
  }

  console.log(MainValue, "MainValue");

  const [tabsOrientation, setTabsOrientation] = useState("horizontal"); //Used to store the orientation of the tabs
  const [tabValue, setTabValue] = useState(MainValue || "Employee");

  const [subTabValue, setSubTabValue] = useState(0); //Used to store current selected tab

  const [tabs, setTabs] = useState([
    {
      id: "all",
      name: "All",
      count: 1,
    },
    {
      id: "employee",
      name: "Employee",
      count: 0,
    },
    {
      id: "manager",
      name: "Manager",
      count: 2,
    },
  ]); // Used to show tabs name and passing id to database

  const [userDetails, setUserDetails] = useState({
    department: "",
    designation: "",
    employeeType: "",
  });
  const [leaveList, setLeaveList] = useState([]);
  const [managerRequestList, setManagerRequestList] = useState([]);

  // useEffect(() => {
  //   EmployeeLeaveDetails();
  //   ManagerRquestDetails();
  // }, []);

  useEffect(() => {
    getteamleadeID();
    const tabName = JSON.parse(sessionStorage.getItem("MainApp"));

if(tabName){
  setTabValue(tabName);
}else{
  setTabValue("Employee");
}

  }, []);

  const [TeamLeaderID, setTeamLeaderID] = useState([]);

  const getteamleadeID = async () => {
    const query = `  
   query{
  allManagers{
    id
    status
    lastupdate
    user{
      id
      empid
      department
      firstName
      lastName
      primaryDelegation{
        primaryDor{
          username
        }
        secondaryDor{
          username
        }
        followUpTasks
      }
    }
  }
}
`;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const managerList = response.data.data.allManagers;
      const filterdata = managerList.filter(
        (val) => val.user.empid == user.empid
      );
      let dataid = filterdata[0]?.user?.id;
      localStorage.setItem("team", dataid);
      setTeamLeaderID(filterdata);
      console.log("filterdatafilterdata:", filterdata);

      // setManagerList(managerList);
      // setPageState({ ...pageState, loading: false, state: "success" });

      console.log("Response:", managerList);
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  useEffect(() => {
    // onManagerDetails();
    // onEmployeeDetails();
    // requesthrlist();

    setTimeout(() => {
      if (tabValue) {
        datahandelar();
      }
    }, 2000);

    console.log("tabValuetabValue:", tabValue);
  }, [tabValue]);

  const requesthrlist = async () => {
    const query = `query TeamLeaveAll($id: String!) {
    requestsForLeaveTeamAll(id: $id) {
      id
      teamleaderId
      requestedOn
      leaveType{
      leaveType
      }
      leaveFrom
      leaveTill
      totalDays
      halfDay
      reason
      teamApproval
      hrApproval
      status
      user {
        id
        empid
        username
        firstName
      }
    }
  }`;

    const encodedId = btoa(user?.id);
    let data = "VXNlck5vZGU6" + "" + encodedId;
    console.log("EMPIDDDD:", user?.empid);

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: {
            id: "VXNlck5vZGU6" + "" + encodedId, // Use the encodedId here
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("responseREQQQQ:", response.data);
    } catch (error) {
      console.error("errorwwww:", error.response.data);
    }
  };

  const leaveListTable = {
    columns: [
      {
        field: "username",
        headerName: "User Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "leaveType",
        headerName: "Leave Type",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "leaveFrom",
        headerName: "Leave From",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "leaveTill",
        headerName: "Leave Till",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "primaryDor",
        headerName: "Primary DOR",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      // {
      //   field: "secondaryDor",
      //   headerName: "Secondary DOR",
      //   flex: 1,
      //   disableColumnMenu: true,
      //   editable: false,
      //   sortable: true,
      // },
      {
        field: "totalDays",
        headerName: "Total Days",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "reason",
        headerName: "Reason",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "Allstatus",
        headerName: "Status",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
    ],
    rows: leaveList
      .map((leave) => ({
        id: leave.id,
        username: leave.user.firstName
          ? leave.user.firstName.charAt(0).toUpperCase() +
            leave.user.firstName.slice(1)
          : "",

        requestedOn: leave.requestedOn,
        leaveType: leave.leaveType?.name
          .replace(/_/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase()),

        leaveFrom: leave.leaveFrom,
        leaveTill: leave.leaveTill,
        primaryDor: leave.primaryDor?.firstName,
        secondaryDor: leave.secondaryDor?.firstName,
        totalDays: leave.totalDays,
        reason: leave.reason,

        teamApproval: leave.teamApproval
          ? leave.teamApproval.charAt(0).toUpperCase() +
            leave.teamApproval.slice(1)
          : "",

        hrApproval: leave.hrApproval
          ? leave.hrApproval.charAt(0).toUpperCase() + leave.hrApproval.slice(1)
          : "",
        Allstatus:
          leave.status == "pending"
            ? leave.approvalStatus !== null
              ? `Pending By ${leave.approvalStatus?.approver?.firstName} ${leave.approvalStatus?.approver?.lastName}`
              : leave?.hrApproval == "pending"
              ? "Pending By Hr"
              : "Approved By Hr"
            : leave.status == "rejected"
            ? "Rejected"
            : leave.status == "approved"
            ? "Approved"
            : leave.status == "Cancelled"
            ? "Cancelled"
            : "",
        status: leave.status?.charAt(0).toUpperCase() + leave.status?.slice(1),
      })),
  };

  const handleNewLeave = () => {
    setLeaveShow(true);
    navigate("/appyleave/apply-leaverequest");
    setleavedisplay(false);
  };
  const onLeaveListClick = (e) => {
    setleavedisplay(true);

    if (e?.id) {
      if (tabValue == "HR") {
        navigate(`/appyleave/leaveapproval?id=${e?.id}`);
        return;
      } else if (tabValue == "HRList") {
        navigate(`/appyleave/leaveapproval?id=${e?.id}`);
        return;
      } else if (tabValue == "Manager") {
        navigate(`/appyleave/leaveapproval?id=${e?.id}`);
        return;
      } else if (tabValue == "ManagerList") {
        navigate(`/appyleave/leaveapproval?id=${e?.id}`);
        return;
      } else if (
        e.row.hrApproval == "Approved" ||
        e.row.teamApproval == "Approved" ||
        e.row.status == "Approved"
      ) {
        navigate(`/appyleave/viewscreen?id=${e?.id}`);
        return;
      } else {
        setLeaveShow(false);
        navigate(`/appyleave/apply-leaverequest?id=${e?.id}`);
      }

      if (
        e.row.hrApproval == "Pending" &&
        e.row.teamApproval == "Approved" &&
        e.row.status == "Pending"
      ) {
        navigate(`/appyleave/viewscreen?id=${e?.id}`);
        return;
      }
      if (
        e.row.hrApproval == "Rejected" &&
        e.row.teamApproval == "Rejected" &&
        e.row.status == "Rejected"
      ) {
        navigate(`/appyleave/viewscreen?id=${e?.id}`);
        return;
      }
    }
  };

  const handleSetTabValue = (event, newValue) => {
    console.log("event:", newValue);
    if (newValue == "HR") {
      setHRRoleLeave(true);
      // sessionStorage.removeItem('MainApp');
      sessionStorage.setItem("MainApp", JSON.stringify(newValue));
      SetHRLIST(newValue);
    } else if (newValue == "Manager") {
      setManagerLeave(true);
    } else if (newValue == "HRList") {
      sessionStorage.setItem("MainApp", JSON.stringify(newValue));
    } else if (newValue == "ManagerList") {
      sessionStorage.setItem("MainApp", JSON.stringify(newValue));
    } else if (newValue == "Employee") {
      sessionStorage.setItem("MainApp", JSON.stringify(newValue));
    }

    setTabValue(newValue);
  };
  const handleSetSubTabValue = (event, newValue) => {
    setSubTabValue(newValue);
  };

  const datahandelar = async () => {
    handleClearSelection();

    if (tabValue == "HR") {
      const query = `
       query GetAllLeaveDetails {
        leaveDetailsAll {
          id
          user {
            firstName
            username
            lastName
          }
          leaveType {
            id
            name
          }
          leaveFrom
          leaveTill
            primaryDor{
            username
            firstName
          }
          secondaryDor{
            username
             firstName
          }
          approvalStatus{
            id
            approver{
              id
              firstName
              lastName
            }
            status
          }
          followUpTasks
          reason
          totalDays
          teamApproval
          hrApproval
          status
        }
      }
       `;

      const encodedId = btoa(user?.id);

      try {
        setPageState({ ...pageState, loading: true });

        const response = await axios.post(
          BASEURL,
          {
            query: query,
            // variables: {
            //   id: TeamLeaderID[0]?.user.id,
            // },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log("ERRROR1");
        console.log("leavelistHRRR", response.data.data.leaveDetailsAll);
        let leaveHRlist = response.data.data.leaveDetailsAll;
        setLeaveList(leaveHRlist);

        setPageState({ ...pageState, loading: false, state: "success" });
      } catch (error) {
        console.error("ResponseError:", error.response.data);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else if (tabValue == "HRList") {
      const query = `
query AllTeamLeaveRequests($id: String!) {
 
  requestsForLeaveTeamAll(id: $id) {
 
   data {
 
      id
 
      reason
 
      totalDays 
      user{
        id
        firstName
        lastName
      }
      status
      teamApproval
      hrApproval
      teamleaderId
       leaveFrom
          leaveTill
      leaveType{
        id
        name
      }

 
      primaryDor{
 
        firstName
        lastName
 
      }
 
 
      secondaryDor{
 
        firstName
        lastName
 
      } 
      attachment
      approvalStatus{
        id
        approver{
          id
          firstName
          lastName
        }
      }
 
 
      followUpTasks
 
    }
 
    success
 
    error
 
    message
 
  }
 
}
 `;

      const encodedId = btoa(user?.id);
      let reportnum = localStorage.getItem("team");
      try {
        setPageState({ ...pageState, loading: true });
        console.log(TeamLeaderID[0]?.user.id, "teamid");
        const response = await axios.post(
          BASEURL,
          {
            query: query,
            variables: {
              //   id: "VXNlck5vZGU6" + "" + encodedId,
              id: reportnum,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log("ERRROR2");

        const regularizationList =
          response.data.data.requestsForLeaveTeamAll?.data;
      

        setLeaveList(regularizationList);
        setPageState({ ...pageState, loading: false, state: "success" });
      } catch (error) {
        console.error("ResponseError:", error.message);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else if (tabValue == "Manager") {
      const query = `
       query TeamLeavePending($id:String!){

  requestsForLeaveTeam(id:$id){

    data{

      id

    user{

      email

      firstName

    }

    teamleaderId

    requestedOn

    leaveFrom  

      leaveTill

    leaveType{

      id

      name

    }

    leaveFrom

    leaveTill

    totalDays

    halfDay

    reason

    teamApproval

    hrApproval

    status

    }

    message

    success

    error

   }

}
 
 `;

      const encodedId = btoa(user?.id);
      let reportnum = localStorage.getItem("team");
      try {
        setPageState({ ...pageState, loading: true });

        const response = await axios.post(
          BASEURL,
          {
            query: query,
            variables: {
              //   id: "VXNlck5vZGU6" + "" + encodedId,
              id: reportnum,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log("leavelistmanager", response);
        console.log("ERRROR3");
        // Extract department data from the response
        const regularizationList = response.data.data.requestsForLeaveTeam.data;
        setLeaveList(regularizationList);
        setPageState({ ...pageState, loading: false, state: "success" });
      } catch (error) {
        console.error("ResponseError:", error.message);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else if (tabValue == "ManagerList") {
      const query = `
      query AllTeamLeaveRequests($id: String!) {
 
  requestsForLeaveTeamAll(id: $id) {
 
   data {
 
      id
 
      reason
 
      totalDays 
      user{
        id
        firstName
        lastName
      }
      status
      teamApproval
      hrApproval
      teamleaderId
       leaveFrom
          leaveTill
      leaveType{
        id
        name
      }

 
      primaryDor{
 
        firstName
        lastName
 
      }
 
 
      secondaryDor{
 
        firstName
        lastName
 
      } 
      attachment
      approvalStatus{
        id
        approver{
          id
          firstName
          lastName
        }
      }
 
 
      followUpTasks
 
    }
 
    success
 
    error
 
    message
 
  }
 
}
 
            `;

      const encodedId = btoa(user?.id);
      console.log("SVHVS:", TeamLeaderID[0]?.user.id);

      let reportnum = localStorage.getItem("team");

      try {
        setPageState({ ...pageState, loading: true });

        const response = await axios.post(
          BASEURL,
          {
            query: query,
            variables: {
              //   id: "VXNlck5vZGU6" + "" + encodedId,
              id: reportnum,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log("leavelist", response);
        console.log("ERRROR4");
        // Extract department data from the response
        const regularizationList =
          response.data.data.requestsForLeaveTeamAll.data;
        setLeaveList(regularizationList);
        setPageState({ ...pageState, loading: false, state: "success" });
      } catch (error) {
        console.error("ResponseError:", error.message);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else {
      const query = `
      query LeaveRequestsByMe($id: String!) {
 
  leaveRequestsByMe(id: $id) {
 
    data {
 
      id
 
      reason
     leaveFrom  
      leaveTill
      totalDays 
      user{
        id
        firstName
        lastName
      }
      status
      teamApproval
      hrApproval
      teamleaderId
      leaveType{
        id
        name
      }

 
      primaryDor{
 
        firstName
        lastName
 
      }
 
 
      secondaryDor{
 
        firstName
        lastName
 
      } 
      attachment
      approvalStatus{
        id
        approver{
          id
          firstName
          lastName
        }
      }
 
 
      followUpTasks
 
    }
 
    success
 
    error
 
    message
 
  }
 
} 
      `;
      console.log(user, "usr");
      const encodedId = btoa(user?.id);

      try {
        setPageState({ ...pageState, loading: true });

        console.log(encodedId, "enid");

        const response = await axios.post(
          BASEURL,
          {
            query: query,
            variables: { id: user?.id },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const leaveList = response.data.data.leaveRequestsByMe?.data;
        console.log("ERRROR5");
        setLeaveList(leaveList);
        setPageState({ ...pageState, loading: false, state: "success" });
      } catch (error) {
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    }
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Leave list
                </MaterialTypography>
              </Stack>

              <MaterialBox
                display="flex"
                justifyContent={{ md: "flex-end" }}
                alignItems="center"
                width="60%"
              >
                <MaterialBox width="80%">
                  <AppBar position="static">
                    <Tabs
                      orientation={tabsOrientation}
                      value={tabValue}
                      onChange={handleSetTabValue}
                      sx={{
                        backgroundColor: "#f8f9fa", // Light background
                        borderRadius: "12px",
                        padding: "5px",
                      }}
                    >
                      {AccessData &&
                        Array.isArray(AccessData) &&
                        AccessData.some(
                          (item) =>
                            item.component === "HrApproval" && item.can_access
                        ) && (
                          <Tab
                            label="HR List"
                            value="HR"
                            sx={{
                              transition: "0.3s",
                              "&:hover": {
                                backgroundColor: "#e5e8ec",
                                color: "#fff",
                                borderRadius: "8px",
                              },
                            }}
                          />
                        )}
                      {AccessData &&
                        Array.isArray(AccessData) &&
                        AccessData.some(
                          (item) =>
                            (item.component === "HrApproval" &&
                              item.can_access) ||
                            (item.component === "ManagerApproval" &&
                              item.can_access)
                        ) && (
                          <Tab
                            label="Team List"
                            value="HRList"
                            sx={{
                              color: "#2c5da8",
                              transition: "0.3s",
                              "&:hover": {
                                backgroundColor: "#e5e8ec",
                                color: "#1348a5",
                                borderRadius: "8px",
                              },
                            }}
                          />
                        )}

                      {/* {AccessData &&
                        Array.isArray(AccessData) &&
                        AccessData.some(
                          (item) =>
                            item.component === "ManagerApproval" &&
                            item.can_access
                        ) && (
                          <Tab
                            label="Team List"
                            value="ManagerList"
                            sx={{
                              color: "#2c5da8",
                              transition: "0.3s",
                              "&:hover": {
                                backgroundColor: "#e5e8ec",
                                color: "#1348a5",
                                borderRadius: "8px",
                              },
                            }}
                          />
                        )} */}

                      <Tab
                        label="My List"
                        value="Employee"
                        sx={{
                          color: "#2c5da8",
                          transition: "0.3s",
                          "&:hover": {
                            backgroundColor: "#e5e8ec",
                            color: "#1348a5",
                            borderRadius: "8px",
                          },
                        }}
                      />
                    </Tabs>
                  </AppBar>
                </MaterialBox>
              </MaterialBox>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) => item.component === "AddLeave" && item.can_access
                ) && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleNewLeave()}
                  >
                    Apply Leave
                  </MaterialButton>
                )}
            </Stack>
          }
        />
        <MaterialDataGrid
          rows={leaveListTable.rows}
          customHeight={500}
          columns={leaveListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onLeaveListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No leave found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any leave details. Click on the "Add
                  leave" button to start adding leave details.
                </MaterialTypography>
              </Stack>
            ),
          }}
          subTab={
            (userDetails?.designation === "PEOPLE MANAGER" ||
              userDetails?.designation === "Project Manager") && (
              <AppBar position="static">
                <Tabs
                  orientation={tabsOrientation}
                  value={subTabValue}
                  onChange={handleSetSubTabValue}
                  sx={{ backgroundColor: "transparent" }}
                >
                  <Tab label="All" />
                  <Tab label="Pending Request" />
                  <Tab label="Approved" />
                  <Tab label="Rejected" />
                </Tabs>
              </AppBar>
            )
          }
        />
      </Card>
    </DashboardLayout>
  );
};

export default LeaveManagement;
